
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import {
    getConditionOperatorForAttribute,
    SelectAttribute,
    SelectAttributeValue,
    SelectConditionOperator
} from '../../core';

let resolve;

class DialogAttributeCondition extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogAttributeCondition />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            attributes: [],
            name: '',
            nameReadOnly: false,
            operator: '',
            value: ''
        };
    }

    getAttribute = (id) => {
        return this.state.attributes.reduce((previous, current) => {
            return (current.id === id) ? current : previous;
        }, null);
    }

    getIsValid = () => {
        return this.state.name && this.state.operator && this.state.value;
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    handleOk = () => {
        if (this.getIsValid()) {
            this.setState({hidden: true});
            resolve({
                name: this.state.name,
                operator: this.state.operator,
                value: this.state.value
            });
        }
    }

    handleSetAttribute = (value) => {
        const attribute = this.getAttribute(value);
        const conditionOperators = getConditionOperatorForAttribute(attribute);
        const operator = (
            this.state.operator ||
            (conditionOperators.length > 0) ? conditionOperators[0].key : ''
        );

        this.setState({
            name: value,
            operator: operator
        });
    }

    handleSetOperator = (value) => {
        this.setState({
            operator: value
        });
    }

    handleSetValue = (value) => {
        this.setState({
            value: value
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    title: 'Zadejte parametry podmínky pro vyhledávání',
                    type: DialogType.normal
                }}
                modalProps={{
                    isBlocking: true,
                    dragOptions: {}
                }}
                >
                {this.renderContent()}
                <DialogFooter>
                    <PrimaryButton onClick={this.handleOk} text="Ok" disabled={!this.getIsValid()} />
                    <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    renderContent = () => {
        const attribute = this.getAttribute(this.state.name);

        return (
            <Stack>
                <SelectAttribute
                    attributes={this.state.attributes}
                    readOnly={this.state.nameReadOnly}
                    value={this.state.name}
                    onChange={this.handleSetAttribute}
                />
                <SelectConditionOperator
                    attribute={attribute}
                    conditionOperators={getConditionOperatorForAttribute(attribute)}
                    value={this.state.operator}
                    onChange={this.handleSetOperator}
                />
                <SelectAttributeValue
                    attribute={attribute}
                    value={this.state.value}
                    onConfirm={this.handleOk}
                    onChange={this.handleSetValue}
                />
            </Stack>
        );
    }

    show(attributes, name, operator, value) {
        this.setState({
            hidden: false,
            attributes: attributes,
            name: name,
            nameReadOnly: !!name,
            operator: operator,
            value: value
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogAttributeCondition.create();
